export enum AUTH_STATUS {
  authenticating = 'authenticating',
  authenticated = 'authenticated',
  anonymous = 'anonymous',
}
